/** this layout is for pages having no subsidebar */
import ClientSessionHandler from 'components/ClientSessionHandler';
import { AppContent, AppSidebar } from 'components/elements/inner/index';
import { flashMessageSelector, setFlashMessage } from 'features/adminUI/adminUISlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const BasicLayout = ({children}) => {

  const flashMessage = useSelector(flashMessageSelector);
  const dispatch = useDispatch();

  useEffect(() => {

    if(flashMessage) {
      setTimeout(() => {
        dispatch(setFlashMessage(undefined));
      }, 10000);
    }

  }, [flashMessage]);

  return (
      <ClientSessionHandler>
            <div>
                  <AppSidebar />
                  <div className="wrapper d-flex flex-column min-vh-100">
                  <div className="body flex-grow-1 px-3">
                        <AppContent>
                          <>                          
                            {flashMessage && (
                              <div
                                className="alert alert-success px-3 pt-2 pb-2 mb-1 mt-3 text-align-center"
                                style={{textAlign: "left"}}
                              >
                                {flashMessage}
                              </div>
                            )}
                              {children}
                          </>
                        </AppContent>
                        </div>
            
                  </div>
            </div>
       </ClientSessionHandler>
  )
}

export default BasicLayout;
